import { FC, ImgHTMLAttributes } from 'react';

interface Props extends ImgHTMLAttributes<HTMLImageElement> {
  name: string;
}

const Icon: FC<Props> = ({ name, ...otherProps }) => {
  return (
    <img src={`${process.env.REACT_APP_ICON_ENDPOINT + name}.svg`} alt={name} {...otherProps} />
  );
};
export default Icon;
